import * as React from 'react';

interface Props {
  children: any;
}

export default function HelpHint(props: Props) {
  return (
    <blockquote className="lh-copy bl bw3 b--gold pv3 pl3 ma0 mb4 f6 bg-washed-yellow">
      {props.children}
    </blockquote>
  );
}
